export default __webpack_public_path__ + "static/media/barber_front.4629cb92.png";